import { getLanguage } from './getLanguage';
import { replacePlaceholders } from './replacePlaceholders';
import { Translations } from './translations';
export const getTranslation = (key, { locale, params } = {}) => {
    const language = locale || getLanguage();
    let translationString = Translations[key][language];
    if (params && translationString) {
        translationString = replacePlaceholders(translationString, params).join('');
    }
    return translationString;
};
